import { createContext, useContext, useState } from "react";
import { UserInfoDTO } from "./dao/DTOs";

export type GVContextProps = {

  /** */
  user: UserInfoDTO | null;
  setUser: React.Dispatch<React.SetStateAction<UserInfoDTO | null>>;
  IsAdmin: () => boolean;

}


/* GV -- GlobalValues */
export const GVContext = createContext<null | GVContextProps>(null);

export function useGVInit(): GVContextProps {


  const [user, setUser] = useState<UserInfoDTO | null>(null);

  function IsAdmin() {
    return user?.role === "admin";
  }
  const re: GVContextProps = {
    IsAdmin,
    user, setUser
  };

  return re;
}



export function useGV(): GVContextProps {
  const GV = useContext(GVContext);

  if (GV == null) {
    throw new Error("缺少 GV !!!");
  }

  return GV;
}
